module.exports = __webpack_public_path__ + "static/media/facebook.b9fc5c48.svg";